import React from "react";
import Skeleton from "react-loading-skeleton";

const Table = ({ columns, data, status, onDelete}) => {
  console.log(data);
  return (
    <div className="table-responsive">
      <table className="table table-hover">
        <thead className="table-primary">
          <tr>
            {columns.map((column, index) => (
              <th key={index} scope="col">
                {column.label}
              </th>
            ))}
            <th scope="col">Download</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {status === "loading" && (
            <tr className="my-2">
              <td colSpan={columns.length + 2}>
                <Skeleton count={10} height={40} />
              </td>
            </tr>
          )}
          {status === "failed" && (
            <tr>
              <td colSpan={columns.length + 2}>
                <p className="text-center fw-bold">{"Data not found"}</p>
              </td>
            </tr>
          )}
          {status === "succeeded" &&
            data.map((item, index) => (
              <tr key={item._id}>
                {columns.map((column, colIndex) => (
                  <td key={colIndex}>
                    {column.accessor
                      ? column.accessor === "serialNumber"
                        ? index + 1
                        : column.formatter
                        ? column.formatter(item[column.accessor])
                        : item[column.accessor]
                      : ""}
                  </td>
                ))}
                <td>
                  <a href={item.Pdf} target="_blank">
                  <i class="bi bi-cloud-download-fill"></i>
                  </a>
                </td>
                <td>
                  <div className="cursor" onClick={() => onDelete(item._id)}>
                    <i className="bi bi-trash text-danger fs-5"></i>
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
